import type { MeetingTemplateKind } from '@wundo/shared/meetingTemplate.ts';

/** How the console names each kind of meeting a conversation type is for. */
export interface MeetingTemplateKindText {
  /** Heading of the list section holding this kind. */
  section: string;
  newTemplate: string;
  defaultMarker: string;
  makeDefault: string;
  emptyMessage: string;
  /** Why the default of this kind cannot be deleted. */
  deleteRefusal: string;
}

export const MEETING_TEMPLATE_KINDS: readonly MeetingTemplateKind[] = [
  'one_on_one',
  'team',
  'other',
];

export const MEETING_TEMPLATE_KIND_TEXT: Record<
  MeetingTemplateKind,
  MeetingTemplateKindText
> = {
  one_on_one: {
    section: '1:1 conversations',
    newTemplate: 'New 1:1 type',
    defaultMarker: 'Default for 1:1',
    makeDefault: 'Make default for 1:1',
    emptyMessage: 'No 1:1 conversation types.',
    deleteRefusal: 'This is the default for 1:1s. Make another type the default first.',
  },
  team: {
    section: 'Team meetings',
    newTemplate: 'New team meeting type',
    defaultMarker: 'Default for team meetings',
    makeDefault: 'Make default for team meetings',
    emptyMessage: 'No team meeting types.',
    deleteRefusal:
      'This is the default for team meetings. Make another type the default first.',
  },
  other: {
    section: 'Other meetings',
    newTemplate: 'New type for other meetings',
    defaultMarker: 'Default for other meetings',
    makeDefault: 'Make default for other meetings',
    emptyMessage: 'No types for other meetings.',
    deleteRefusal:
      'This is the default for other meetings. Make another type the default first.',
  },
};

/** A kind read from a URL, or nothing when it names none. */
export function meetingTemplateKindFrom(value: unknown): MeetingTemplateKind | undefined {
  return MEETING_TEMPLATE_KINDS.find((kind) => kind === value);
}
